import { CommonAPI } from "../CommonAPI/CommonAPI";
import Cookies from "js-cookie";

export const EmployeeActive = async (Mode, userId, status, modeActive) => {
  let response;
  try {
    // const token = "LGN103D12R6A17HG4CAI";
    // const DeviceToken = "U015UW9PV4JY9S9A";
    const queryParams = new URLSearchParams(window.location.search);

    const device_token_url = queryParams.get("device_token");
    const token_url = queryParams.get("token");
    const SV_url = queryParams.get("SV");

    const cookie_device_token = Cookies.get("device_token");
    const cookie_token = Cookies.get("token");
    const cookie_SV = Cookies.get("SV");

    const DeviceToken = sessionStorage.getItem("device_token") ?? "";
    const token = sessionStorage.getItem("token") ?? "";
    const SV = sessionStorage.getItem("SV") ?? "";

    const finalToken =
      window.location.hostname === "localhost" ||
      window.location.hostname === "nzen"
        ? "LGN103D12R6A17HG4CAI"
        : token || token_url || cookie_token || "";

    const finalDeviceToken =
      window.location.hostname === "localhost" ||
      window.location.hostname === "nzen"
        ? "U015UW9PV4JY9S9A"
        : DeviceToken || cookie_device_token || device_token_url || "";

    const finalSv =
      window.location.hostname === "localhost" ||
      window.location.hostname === "nzen"
        ? "0"
        : SV || SV_url || cookie_SV || "";

    let statusf = status == 1 ? 0 : 1;

    let requestData = {
      Token: finalToken,
      DeviceToken: finalDeviceToken,
      Mode: Mode,
      EmployeeId: userId,
    };

    if (modeActive === "IsRoaming") {
      requestData.IsRoaming = statusf;
    } else if (modeActive === "IsLogin") {
      requestData.IsLogin = statusf;
    } else {
      requestData.IsActive = statusf;
    }

    const combinedValue = JSON.stringify(requestData);

    const body = {
      Token: finalToken,
      DeviceToken: finalDeviceToken,
      SV: finalSv,
      ReqData: combinedValue,
    };

    response = await CommonAPI(body);
  } catch (error) {
    console.error("Error:", error);
  }
  return response;
};
